/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { newDocumentGetNewDocumentList } from '../fn/new-document/new-document-get-new-document-list';
import { NewDocumentGetNewDocumentList$Params } from '../fn/new-document/new-document-get-new-document-list';
import { NewDocumentList } from '../models/new-document-list';

@Injectable({ providedIn: 'root' })
export class NewDocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `newDocumentGetNewDocumentList()` */
  static readonly NewDocumentGetNewDocumentListPath = '/new-document/list';

  /**
   * Get new documents for the current user.
   *
   * Get new documents for the current user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newDocumentGetNewDocumentList()` instead.
   *
   * This method doesn't expect any request body.
   */
  newDocumentGetNewDocumentList$Response(params?: NewDocumentGetNewDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<NewDocumentList>> {
    const obs = newDocumentGetNewDocumentList(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get new documents for the current user.
   *
   * Get new documents for the current user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newDocumentGetNewDocumentList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newDocumentGetNewDocumentList(params?: NewDocumentGetNewDocumentList$Params, context?: HttpContext): Observable<NewDocumentList> {
    const resp = this.newDocumentGetNewDocumentList$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<NewDocumentList>): NewDocumentList => r.body)
    );
  }

}
